import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { EduCourse } from '@common/types/edu-course.type';

import { Injectable } from '@angular/core';
import { map, shareReplay } from 'rxjs';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class EduCoursesHttpService extends BaseHttpService {
    public getEduCourses(): Observable<EduCourse[]> {
        return this.http.get<HttpDataResponse<EduCourse[]>>(this.formatEduServiceApiUrl('courses')).pipe(
            shareReplay(),
            map((response) => response.data)
        );
    }

    public getEduCoursesGroups(courseId): Observable<any[]> {
        return this.http.get<HttpDataResponse<any[]>>(this.formatEduServiceApiUrl(`courses/${courseId}/groups`)).pipe(
            shareReplay(),
            map((response) => response.data)
        );
    }
}
